module.exports = __webpack_public_path__ + "media/bootstrap-icons/dice-1-8aae2877.svg";